// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__3mEg3","search":"Search_search__-F5Qo","searchButton":"Search_searchButton__WRiif"};